module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('div', {
    staticClass: "index-header"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": '/static/img' + _vm.developer.header,
      "alt": ""
    },
    on: {
      "click": _vm.gotoCenter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_vm._v("亲，欢迎使用众联云打印服务")]), _vm._v(" "), _c('div', {
    staticClass: "tips-item"
  }, [_c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-label"
  }, [_vm._v("Appid")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.developer.appid))])]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appid
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips-item"
  }, [_c('div', {
    staticClass: "app-info"
  }, [_c('div', {
    staticClass: "app-label"
  }, [_vm._v("Secret")]), _vm._v(" "), (_vm.showSecret) ? _c('div', [_vm._v(_vm._s(_vm.developer.appSecret))]) : _c('div', [_vm._v(_vm._s(_vm.developer.appSecretDot))])]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-fuzhi",
    attrs: {
      "data-clipboard-text": _vm.developer.appSecret
    }
  }), _vm._v(" "), (_vm.showSecret) ? _c('div', {
    staticClass: "eye iconfont icon-guan",
    on: {
      "click": _vm.changeShowSecret
    }
  }) : _c('div', {
    staticClass: "eye iconfont icon-kai",
    on: {
      "click": _vm.changeShowSecret
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("亲，这是您第 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.loginTimes))]), _vm._v(" 次登录管理后台，")], 1), _vm._v(" "), _c('div', {
    staticClass: "offical-link",
    on: {
      "click": _vm.gotoLog
    }
  }, [_vm._v("查看登录日志")])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('div', [_vm._v("您已绑定 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.printerCount))]), _vm._v(" 台设备，")], 1), _vm._v(" "), _c('div', {
    staticClass: "offical-link",
    on: {
      "click": _vm.gotoPrinter
    }
  }, [_vm._v("设备管理")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-logs"
  }, [(_vm.logList && _vm.logList[0]) ? _c('div', {
    staticClass: "login-log login-log-curr"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("IP段：" + _vm._s(_vm.logList[0].ip))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("地址：" + _vm._s(_vm.logList[0].address))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("\n                        时间：" + _vm._s(_vm.logList[0].createTime) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.logList && _vm.logList[1]) ? _c('div', {
    staticClass: "login-log login-log-prev"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("IP段：" + _vm._s(_vm.logList[1].ip))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("地址：" + _vm._s(_vm.logList[1].address))]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_vm._v("时间：" + _vm._s(_vm.logList[1].createTime))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "shops"
  }, _vm._l((_vm.shops), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "shop-item",
      on: {
        "click": function($event) {
          return _vm.gotoShop(item.link)
        }
      }
    }, [_c('img', {
      staticClass: "shop-logo",
      attrs: {
        "src": item.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "shop-name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "news-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('el-timeline', _vm._l((_vm.activities), function(activity, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "icon": activity.icon,
        "type": activity.type,
        "color": activity.color,
        "timestamp": activity.timestamp
      }
    }, [_vm._v("\n                        " + _vm._s(activity.content) + "\n                    ")])
  }), 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "iconfont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-tips"
  }, [_vm._v("本次登录信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-header"
  }, [_c('div', {
    staticClass: "iconfont icon-dizhi"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-tips"
  }, [_vm._v("上次登录信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcodes"
  }, [_c('div', {
    staticClass: "qrcode-item"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("开发问题咨询请扫描添加上方微信")])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-item"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": "/static/img/wx.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("消息通知扫描关注“众联云助手”公众号")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "iconfont icon-gonggao"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("系统公告")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("尊敬的用户：")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("您好！")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("\n                    众联云打印服务是由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("\n                    我们的产品有云打印机、蓝牙云盒、云喇叭等，通过众联云数据中心的数据聚合能力，结合稳定高效的WiFi/4G/5G通讯技术，实现24小时全天候不漏单智能打印和语音播报，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("众联云打印团队在此深深感谢大家长期以来的支持与厚爱，接下来我们会更加努力，给您提供更优质更全面的服务！！")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "space"
  }, [_vm._v("祝商祺!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "yin-container"
  }, [_c('img', {
    staticClass: "yin",
    attrs: {
      "src": "/static/img/yin.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("\n                        众联云打印团队\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("\n                        2022年10月10日\n                    ")])]), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "iconfont icon-jiekou"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-label"
  }, [_vm._v("最新动态")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4af023c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/index.vue
// module id = 345
// module chunks = 1